import { differenceInYears, parseISO } from 'date-fns';

/**
 * Whole years since `dateOfBirth`, or null when the member has no DOB on record.
 *
 * `parseISO`, not `new Date(...)`: the latter reads a bare "1974-03-02" as UTC midnight and then
 * renders it in local time, which lands on the previous day for anywhere west of Greenwich and
 * makes the age read one year low for the whole day around a birthday.
 */
export function memberAge(dateOfBirth: string | null, today: Date = new Date()): number | null {
  if (!dateOfBirth) return null;
  const parsed = parseISO(dateOfBirth);
  if (Number.isNaN(parsed.getTime())) return null;
  return differenceInYears(today, parsed);
}
